/**
 * LibrarySkeleton — placeholder for the catalog tabs while data loads.
 * Uses the shared SkeletonCardGrid behind a 200ms useDelayedFlag so fast
 * loads never flash the skeleton in-and-out.
 */

import { SkeletonCardGrid } from '../../components/Skeleton.tsx';
import { useDelayedFlag } from '../../hooks/useDelayedFlag.ts';

export function LibrarySkeleton() {
  const show = useDelayedFlag(true);
  if (!show) return <div style={{ minHeight: '40vh' }} />;
  return (
    <div className="record-surface record-surface--tabs-only">
      <SkeletonCardGrid count={6} />
    </div>
  );
}
